export default __webpack_public_path__ + "static/media/fiolet_zone.8655d359.svg";